import { userHasInterestForTopic } from "./resolveTopicBackendIds";

function sessionUnlockKey(topicIds) {
  if (!topicIds) return "";
  return `ibx-topic-interest:${topicIds.categoryId}:${topicIds.subCategoryId}`;
}

/** Signed-in consumer with this subcategory in their interests (or session unlock after adding it). */
export function isTopicContentAccessGranted(isAuthenticated, user, topicIds) {
  if (!isAuthenticated || !user || !topicIds) return false;
  if (userHasInterestForTopic(user, topicIds)) return true;
  if (typeof window === "undefined") return false;
  try {
    return Boolean(window.sessionStorage.getItem(sessionUnlockKey(topicIds)));
  } catch {
    return false;
  }
}
